import {axios, HOST, config} from './settiing';

export default {
  getCenterManageInfo(service) {
    return axios.get(`${HOST}/resource/center/manage/${service}`, config);
  },

  getCenterInfoById(id) {
    return axios.get(`${HOST}/resource/centerInfo/${id}`, config);
  },

  getCenterManageInfoById(id) {
    return axios.get(`${HOST}/resource/center/${id}`, config);
  },

  addCenterInfo(data){
    return axios.post(`${HOST}/resource/center`, data, config);
  },

  deleteCenterInfo(id) {
    return axios.delete(`${HOST}/resource/center/${id}`, config);
  },

  updateCenterInfo(data) {
    return axios.put(`${HOST}/resource/center`, data, config);
  },

  updateCenterFareInfo(data) {
    return axios.put(`${HOST}/resource/center/fare`, data, config);
  },

  getCenter(service) {
    return axios.get(`${HOST}/resource/center/by/${service}`, config);
  },

  getUseList(){
    return axios.get(`${HOST}/resource/center/use`, config);
  },

  updateUseList(data) {
    return axios.post(`${HOST}/resource/center/use`, data, config);
  }
}